export function removeFromQueue(data) {
	return {type: "REMOVE_FROM_QUEUE", data: data}
}
